import { render, staticRenderFns } from "./RestaurantTypeUpsertDialog.vue?vue&type=template&id=4247c00a"
import script from "./RestaurantTypeUpsertDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantTypeUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports